import supabase from '../utils/supabase'

export async function checkVerified(userId) {
  const {data: verified} = await supabase
    .from("verified")
    .select("created_at")
    .eq("user_id", userId)
    .single();
  return !!verified;
}